import React, { useEffect, useState } from "react";
import AmberImageList from "../components/TheAmberSuite/AmberImageList";
import Container from "../components/Container";
import image from "../assets/AmberSuiteImg/AS1.jpg";
import TopBannerSection from "../components/TopBannerSection";
import AmberMobileImageList from "../components/TheAmberSuite/AmberMobileImageList";
import AmberSuitsDescription from "../components/TheAmberSuite/AmberSuitsDescription";
import AmberSuitesDetail from "../components/TheAmberSuite/AmberSuitesDetail";
import Amenities from "../components/suites/Amenities";
import AmberPrice from "../components/TheAmberSuite/AmberPrice";
import AmberOtherSuites from "../components/TheAmberSuite/AmberOtherSuites";

const TheAmberSuite = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container>
      <TopBannerSection Image={image} Quote={"The Amber Suite"} />
      <br />
      {isDesktop ? <AmberImageList /> : <AmberMobileImageList />}
      <AmberSuitsDescription />
      <AmberSuitesDetail />
      <Amenities />
      <AmberPrice />
      <AmberOtherSuites />
    </Container>
  );
};

export default TheAmberSuite;
